import { render } from "./InfoBoxValue.vue?vue&type=template&id=c01256fe&scoped=true"
import script from "./InfoBoxValue.vue?vue&type=script&lang=js"
export * from "./InfoBoxValue.vue?vue&type=script&lang=js"

import "./InfoBoxValue.vue?vue&type=style&index=0&id=c01256fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01256fe"]])

export default __exports__